import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from "react-router-dom";
import './index.style';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppProvider from './state/provider';

export const appRootElement = document.getElementById('app') as HTMLElement;
const root = ReactDOM.createRoot(appRootElement);
root.render(
  // <React.StrictMode>
    <Router>
      <AppProvider>
        <App/>
      </AppProvider>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
